/**
 * SizilPro — uiStore
 * Zustand store for UI state: sidebar, modals, notifications.
 */

import { create } from "zustand";

interface Toast {
  id:      string;
  type:    "success" | "error" | "info" | "warning";
  title:   string;
  message?: string;
}

interface UiState {
  // Sidebar
  sidebarOpen: boolean;
  setSidebarOpen: (open: boolean) => void;
  toggleSidebar: () => void;

  // Active modal (string key or null)
  activeModal: string | null;
  openModal:   (key: string) => void;
  closeModal:  () => void;

  // Toast queue (mostly handled by sonner — this is for programmatic use)
  toasts:     Toast[];
  addToast:   (toast: Omit<Toast, "id">) => void;
  removeToast:(id: string) => void;
}

export const useUiStore = create<UiState>((set, get) => ({
  sidebarOpen: true,
  setSidebarOpen: (open) => set({ sidebarOpen: open }),
  toggleSidebar: () => set({ sidebarOpen: !get().sidebarOpen }),

  activeModal: null,
  openModal:   (key) => set({ activeModal: key }),
  closeModal:  () => set({ activeModal: null }),

  toasts: [],
  addToast: (toast) =>
    set((s) => ({
      toasts: [...s.toasts, { ...toast, id: `${Date.now()}_${Math.random()}` }],
    })),
  removeToast: (id) =>
    set((s) => ({ toasts: s.toasts.filter((t) => t.id !== id) })),
}));
